import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

export const FreeRecognition = ({ onBegin }) => {
    return (
        <section id="recognition" data-testid="recognition-section" className="relative px-5 py-28 sm:px-8 lg:py-36">
            <div className="nebula-blob right-[-5%] top-[5%] h-[30rem] w-[30rem] bg-[#5a189a]/25" />
            <div className="nebula-blob bottom-[0%] left-[10%] h-96 w-96 bg-[#2e0b53]/40" />

            <div className="mx-auto grid max-w-6xl items-center gap-14 lg:grid-cols-2">
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.9 }}
                >
                    <p className="eyebrow mb-4">Chapter III · The Recognition</p>
                    <h2 className="text-glow-lilac font-display text-2xl font-bold leading-snug tracking-wide text-[#f8f7ff] sm:text-3xl lg:text-4xl">
                        DO YOU HAVE A LUNAR MIRROR SISTER?
                    </h2>
                    <div className="mt-7 space-y-5 font-cormorant text-lg italic leading-relaxed text-[#e0aaff]/85">
                        <p>Begin with one free private recognition reading directly with Mara.</p>
                        <p>
                            Tell her about the woman whose life strangely resembles your own. Tell her where you struggled
                            while she succeeded, where you were punished while she was praised, and what she received that
                            always felt destined for you.
                        </p>
                        <p>
                            Mara will look directly at the source and give you one clear answer:{" "}
                            <span className="text-[#f8f7ff]">Yes — you appear to have a Lunar Mirror Sister.</span> Or:{" "}
                            <span className="text-[#f8f7ff]">No. This is not a Dichotomy connection. Sometimes life is simply life.</span>
                        </p>
                    </div>
                    <button type="button" onClick={onBegin} data-testid="begin-free-recognition-button" className="btn-glow mt-10">
                        <span className="mirror-sheen absolute inset-0 animate-shimmer-line" />
                        <span className="relative">BEGIN MY FREE RECOGNITION</span>
                    </button>

                    <div className="glass-card mt-10 p-7 sm:p-8">
                        <p className="eyebrow mb-3">Your first answer is free</p>
                        <div className="space-y-4 font-cormorant text-base italic leading-relaxed text-[#e0aaff]/80">
                            <p>
                                Before you pay anything, Mara will identify whether the pattern appears to exist — whether a
                                blessing, opportunity, relationship or piece of destiny may have found its way into the
                                other woman's life instead of yours.
                            </p>
                            <p>
                                If the answer is no, Mara will tell you no. If the answer is yes, you decide whether you
                                want to enter the Back Room and continue speaking with her live.
                            </p>
                        </div>
                        <button type="button" onClick={onBegin} data-testid="ask-mara-free-button" className="btn-ghost-glow mt-6">
                            ASK MARA FOR FREE
                        </button>
                    </div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 1.1 }}
                    className="relative mx-auto hidden aspect-square w-full max-w-md items-center justify-center lg:flex"
                >
                    <div className="portal-ring absolute inset-0 animate-spin-slower rounded-full" />
                    <div className="absolute inset-8 rounded-full border border-silver/20" />
                    <div className="absolute inset-16 animate-pulse-soft rounded-full bg-[#7b2cbf]/20 blur-2xl" />
                    <div className="animate-float-y relative h-72 w-72 overflow-hidden rounded-full ring-1 ring-[#c77dff]/40 shadow-[0_0_60px_rgba(123,44,191,0.45)]">
                        <img src="/assets/sisters-mark.png" alt="The two sisters facing one another" className="h-full w-full object-cover" />
                        <div className="mirror-sheen absolute inset-0" />
                    </div>
                    <Sparkles className="absolute right-10 top-10 h-6 w-6 animate-pulse-soft text-[#e0aaff]/70" />
                </motion.div>
            </div>
        </section>
    );
};
